import React, { FC } from 'react';
import { Button, ButtonProps, makeStyles, Theme } from '@material-ui/core';
import { BigArrowRightIcon } from 'svgs';

interface MoreButtonProps extends ButtonProps {
  onClick: () => void;
}

const useStyles = makeStyles((theme: Theme) => ({
  button: {
    color: theme.palette.common.white,
    fontWeight: 400,
    width: 80,
    height: 80,
    border: `1px solid #fff`,
    backgroundColor: 'transparent',
    zIndex: 20,
    '&:hover': {
      backgroundColor: 'transparent',
    }
  },
}));

const MoreButton: FC<MoreButtonProps> = (props) => {
  const {onClick} = props;
  const classes = useStyles();

  return (
    <Button
      variant={'contained'}
      className={classes.button}
      onClick={onClick}
    >
      <BigArrowRightIcon />
    </Button>
  );
};

export default MoreButton;
